import React, { useContext, useEffect, useRef, useState } from 'react'
import { FootprintTable } from './FootprintTable'
import { Button } from 'primereact/button'
import PrimeDialog from '../../../components/dialog/PrimeDialog';
import AddNewActivity from './dialog/AddNewActivity';
import { useTranslation } from 'react-i18next';
import PrimeConfirmDialog from '../../../components/dialog/PrimeConfirmDialog';
import { row1List } from './mockData/fakeData';
import { useOutletContext } from 'react-router-dom';
import { createCarbonFootprintData, deleteCarbonFootprintData, queryCarbonDataIdInfo, queryCarbonFootprintData, updateCarbonFootprintData } from '../../../utility/service/carbonFootprint-service';
import { checkDpSuccess } from '../../../utility/service/tool-service';
import { SystemLoading,checkLoading } from '../../../store/loadingStore';
import { downloadMultipartFile } from '../../../utility/service/api-file';
import { MessageContext,handleSuccessMessage } from '../../../store/messageStore';
// 原料取得階段
const RawMaterial = ({
    register,
    errors,
    control,
    reset,
    isValid,
    setValue,
    getValues,
    stage = "",
    clearErrors,
    unitCodeList,
    groupCodeList,
    distributionPrincipleList,
    convertBscryptCode,
    trigger,
    watch,
    isEditable
}) => {
    const [addDialog,setAddDialog] = useState(false);
    const [editAction,setEditAction] = useState('add');
    const [rows,setRows] = useState([]);
    const { t } = useTranslation();
    const [currentObj,setCurrentObj] = useState({});
    const [delDialog,setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const { itemObj,setItemObj,action, setAction } = useOutletContext();
    const [carbonDataId,setCarbonDataId] = useState('');
    const [carbonFootprintData,setCarbonFootprintData] = useState([]);
    const [, loading] = useContext(SystemLoading);
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const fileInputRef = useRef();
    
    
    useEffect(()=>{
        if(stage!==''){
            axios_queryCarbonFootprintData({
                carbonFpId:itemObj?.carbonFpId,
                stage:stage
            })
        }
    },[])

    const axios_queryCarbonDataIdInfo = (carbonDataId)=>{
      queryCarbonDataIdInfo({carbonDataId})
        .then((res)=>{
          if(checkDpSuccess(res)){
            let rowData = res?.data?.RespBody;
            setCurrentObj(rowData);
            if((editAction==='copy' || editAction==='edit') && rowData?.fileId!==null){ //如果是copy 又有檔案 將檔案下載改成file存給devicePic
                downloadMultipartFile({
                    fileId:rowData?.fileId
                }).then((res)=>{
                    if(res){
                        const binaryData = res.data;
                        const blob = new Blob([binaryData], { type: 'application/octet-stream' });
                        const file = new File([blob], `${rowData?.fileName}.${rowData?.fileExtension}`, { type: blob.type });
                        // 嘗試將文件設定到文件選擇框
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file);
                        if (fileInputRef?.current) {
                          fileInputRef.current.files = dataTransfer.files;
                        }
                          reset({
                            ...rowData,
                            filePic:file,
                        })
                    }
                })
            }else{
              reset({
                ...rowData
             })
            }
            setAddDialog(true);
            
          }
        })
    }

    const editItem = (item)=>{
      setEditAction('edit');
      setCurrentObj(item);     
      axios_queryCarbonDataIdInfo(item?.carbonDataId);   
    }

    const deleteItem = (rowData)=>{
        setDelObj(rowData)
        setDelDialog(true);
    }

    const confirmDel = ()=>{
      checkLoading(loading);
      deleteCarbonFootprintData({carbonDataId:delObj?.carbonDataId})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
            axios_queryCarbonFootprintData({
              carbonFpId:itemObj?.carbonFpId,
              stage:stage
            })
            setDelDialog(false);
          }
        }).finally(fin=>{checkLoading(loading,false);})
       
    }

    const btnReadMore = ()=>{
      axios_queryCarbonFootprintData({
        carbonFpId:itemObj?.carbonFpId,
        stage:stage,
        carbonDataId:carbonDataId
      },true)
    }

    

    const createItem = ()=>{
        setAddDialog(true);
        reset({
            dataName:'',
            dataGroup:""
        });
        setEditAction('add');
        setCurrentObj({});
        clearErrors();
    }

    const btnConfirm = ()=>{
      checkLoading(loading);
      let fileExtension = (getValues("fileExtension")!==undefined && getValues("fileExtension")!=='')?getValues("fileExtension"):null;
      let fileName = (getValues("fileName")!==undefined && getValues("fileName")!=='')?getValues("fileName"):null;
      let filePic = (getValues("filePic")!==undefined && getValues("filePic")!=='')?getValues("filePic"):null;
      let formData = new FormData();
      //有fileId 但沒有圖片表示要刪除 只傳 fileId 給後端 (刪除圖片)
      if(currentObj?.fileId && filePic===null){  
        formData.append("fileId",currentObj?.fileId);  
        // console.log("刪除圖片");
      }else if(currentObj?.fileId==null && filePic!==null){ //如果沒有fileId 但有file 表示要新增file
          formData.append("filePic",filePic);
          formData.append("fileName",fileName);
          formData.append("fileExtension",fileExtension);
          // console.log("新增file");
      }else if(filePic!==null && currentObj?.fileName!==fileName && currentObj?.fileId!==null){ //如果有圖片 但是檔名不同表示要更新圖片
          formData.append("fileId",currentObj?.fileId); 
          formData.append("filePic",filePic);
          formData.append("fileName",fileName);
          formData.append("fileExtension",fileExtension);
          // console.log("更新file");
      }
      let dataGroupIndex =  groupCodeList?.filter((item)=>item.subitemNo===getValues("dataGroup"))[0]?.index
      let dataUnitIndex = unitCodeList?.filter((item)=>item.subitemNo===getValues("dataUnit"))[0]?.index;
      let coefUnitIndex = unitCodeList?.filter((item)=>item.subitemNo===getValues("coefUnit"))[0]?.index;   
      let distributionReasonIndex = distributionPrincipleList?.filter((item)=>item.subitemNo===getValues("distributionReason"))[0]?.index;     
      let reqBody = {
        carbonFpId:itemObj?.carbonFpId,
        stage:stage,
        dataName:getValues("dataName"),
        dataGroup:convertBscryptCode(getValues("dataGroup"),dataGroupIndex),//Bcrypt
        dataValue:getValues("dataValue"),
        dataUnit:convertBscryptCode(getValues("dataUnit"),dataUnitIndex),//Bcrypt
        distributionRatio:getValues("distributionRatio"),
        supplierAddress:getValues("supplierAddress"),
        coefName:getValues("coefName"),
        coefValue:getValues("coefValue"),
        coefUnit:convertBscryptCode(getValues("coefUnit"),coefUnitIndex),//Bcrypt
        coefSource:getValues("coefSource"),
        comment:getValues("comment"),
        unitRatio:getValues("unitRatio"),
        reliabilityRemark:getValues("reliabilityRemark"),
        dataReliability:getValues("dataReliability"),
        coefReliability:getValues("coefReliability"),
        integrityRemark:getValues("integrityRemark"),
        dataIntegrity:getValues("dataIntegrity"),
        coefIntegrity:getValues("coefIntegrity"),
        timelinessRemark:getValues("timelinessRemark"),
        dataTimeliness:getValues("dataTimeliness"),
        coefTimeliness:getValues("coefTimeliness"),
        locationRemark:getValues("locationRemark"),
        dataLocation:getValues("dataLocation"),
        coefLocation:getValues("coefLocation"),
        technicalRemark:getValues("technicalRemark"),
        dataTechnical:getValues("dataTechnical"),
        coefTechnical:getValues("coefTechnical"),
        dataSource:getValues("dataSource"),
        distributionReason:convertBscryptCode(getValues("distributionReason"),distributionReasonIndex)
      }
      const skipZeroKeys = [
        'dataReliability',
        'coefReliability',
        'dataIntegrity',
        'coefIntegrity',
        'dataTimeliness',
        'coefTimeliness',
        'dataLocation',
        'coefLocation',
        'dataTechnical',
        'coefTechnical',
        'distributionReason'
      ];

      Object.entries(reqBody).forEach(([key, value]) => {
        // 通用過濾條件
        if (value === undefined || value === null || value === '') return;
      
        // 特定欄位額外排除 0 或 "0"
        if (skipZeroKeys.includes(key) && (value === 0 || value === '0')) return;
      
        formData.append(key, value);
      });

      // Object.entries(reqBody).forEach(([key, value]) => {
      //   if (value !== undefined && value !== null && value !== '') {
      //     formData.append(key, value);
      //   }
      // });

      if(editAction==='add'){
        createCarbonFootprintData(formData)
          .then((res)=>{
            if(checkDpSuccess(res)){
              setAddDialog(false);
              handleSuccessMessage(dispatch, t('button.add') + ' ' + t('message.success'));
              axios_queryCarbonFootprintData({
                carbonFpId:itemObj?.carbonFpId,
                stage:stage
              })
              
            }
          }).finally((fin)=>{checkLoading(loading,false);})
      }else if(editAction==='edit'){
        formData.append("carbonDataId",currentObj?.carbonDataId)
        updateCarbonFootprintData(formData)
          .then(res=>{
            if(checkDpSuccess(res)){
              setAddDialog(false);
              handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
              axios_queryCarbonFootprintData({
                carbonFpId:itemObj?.carbonFpId,
                stage:stage
              })
              
            }
          }).finally((fin)=>{checkLoading(loading,false);})
      }

      // for (let key in reqBody) {
      //   const value = reqBody[key];
      //   if (value !== undefined && value !== null && value !== '') {
      //     formData.append(key, value);
      //   }
      // }
    }

    const axios_queryCarbonFootprintData = (reqBody,readMore=false)=>{
        checkLoading(loading);
            queryCarbonFootprintData(reqBody)
              .then((res)=>{
                if(checkDpSuccess(res)){
                  let data =  res?.data?.RespBody?.carbonFootprintDatas;
                  if(data?.length > 0){
                    setCarbonDataId(data[data?.length-1].carbonDataId);
                    if(readMore===true){
                      setCarbonFootprintData((pre)=>{
                        return [...pre,...data] 
                      })
                    }else{
                      setCarbonFootprintData((pre)=>{
                        return [...data]
                      });
                    }
                  }else{
                    if(readMore===false){
                      setCarbonFootprintData([]);
                    }
                  }
                }else{
                  if(readMore===false){
                    setCarbonFootprintData([]);
                  }
                }
              })
              .catch((err)=>{
                console.log(err);
              })
              .finally(() => checkLoading(loading, false))
    }

  return (
    <>
    <Button label={t('button.add')} onClick={()=>{createItem();}} disabled={!isEditable}/>
    <FootprintTable 
        rows={carbonFootprintData}
        btnReadMore = {btnReadMore}
        editItem={editItem}
        deleteItem={deleteItem}
        isEditable={isEditable}
        />

    <PrimeDialog
            scrollByBody={true}
            visible={addDialog}
            title={editAction==='add'?t('button.add'):t('button.edit')}
            size="lg"
            onClose={() => { setAddDialog(false) }}
            onConfirm={() => { btnConfirm(); }}
            disabledConfirm={!isValid || !isEditable}
            bodyTemplate={<>
            <AddNewActivity 
            register = {register}
            errors = {errors}
            control = {control}
            setValue = {setValue}
            editAction={editAction}
            currentObj={currentObj}
            getValues={getValues}
            stage={stage}
            unitCodeList={unitCodeList}
            groupCodeList={groupCodeList}
            distributionPrincipleList={distributionPrincipleList}
            fileInputRef={fileInputRef}
            watch={watch}
            isEditable={isEditable}
            />
            </>}
        ></PrimeDialog>   

       {/* 刪除 */}
    <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => { setDelDialog(false) }}
        onConfirm={() => { confirmDel(); }}
        title={t('button.delete')}
        bodyTemplate={<>{t('conf_del',{name:delObj?.dataName})}</>}
      />     

    </>
  )
}

export default RawMaterial